const DrainageStatistics = () =>
  import('@/views/main/wechatMgmt/drainageStatistics/DrainageStatistics.vue')
export default {
  path: '/main/wechatMgmt/drainageStatistics',
  name: 'DrainageStatistics',
  component: DrainageStatistics
}
